import invariant from 'tiny-invariant';
export const validateMaxLength = props => {
  invariant(!props.maxLength || !props.mask, "input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.");
};
export const validateMaskPlaceholder = props => {
  const {
    mask,
    maskPlaceholder
  } = props;
  invariant(!mask || !maskPlaceholder || maskPlaceholder.length === 1 || maskPlaceholder.length === mask.length, 'input-mask: maskPlaceholder should either be a single character or have the same length as the mask:\n' + `mask: ${mask}\n` + `maskPlaceholder: ${maskPlaceholder}`);
};